// import { useMutation, useQueryClient } from "react-query";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { client } from './api-client';
import { setTokenWithExpiry } from './tokenManager';

export const useLoginAdmin = () => {
  const queryClient = useQueryClient();
  const loginAdmin = async loginData => {
    console.log('loginData', loginData)
    const response = await client('/auth/login-request', {
      method: 'POST',
      data: loginData,
    });

    if (response.error) {
      console.log('response.error', response.error)
      // Assuming that your server returns an 'error' field when login fails
      throw new Error(response.error);
    }

    

    // if (response.access_token) {
    //   console.log('response...', response?.access_token)
    //   localStorage.setItem('token', response?.access_token);
    //   localStorage.setItem('email', response?.email);
    //   localStorage.setItem('username', response?.username);
    //   localStorage.setItem('userid', response?.userid);
    //   queryClient.invalidateQueries('token');
    //   return response;
    // } else {
    //   throw new Error('Unexpected response from the server');
    // }

    if (response.access_token) {
      return response;
    } else {
      throw new Error('Unexpected response from the server');
    }
  };

  // const logout = () => {
  //   localStorage.removeItem('tokenIssueWarned');
  //   localStorage.removeItem('token');
  //   localStorage.removeItem('tokenExpiration');
  //   queryClient.invalidateQueries('token');

  // };

  return useMutation(loginAdmin);
};

export const useCreateUser = () => {
  const registerUser = async registorData => {
    const response = await client('register-request', {
      method: 'POST',
      data: registorData,
    });

    if (response?.error) {
      // Assuming that your server returns an 'error' field when login fails
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(registerUser);
};

export const useForGetPassword = () => {
  const forgetpassword = async verifyPasswordForRegistrationData => {
    const response = await client('auth/request-reset', {
      method: 'POST',
      data: verifyPasswordForRegistrationData,
    });

    if (response?.error) {
      // Assuming that your server returns an 'error' field when login fails
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(forgetpassword);
};

export const useVerifyOtp = () => {
  return useMutation(
    async (verifyOtpAndResetPassword) => {
      const response = await client('reset_password', {
        method: 'POST',
        data: verifyOtpAndResetPassword,
      });

      if (response?.error) {
        throw new Error(response.error);
      }

      return response;
    },
    {
      onSuccess: (data) => {
        console.log('✅ OTP Verified - response in useMutation:', data);
      },
      onError: (error) => {
        console.error('❌ OTP Verification Failed:', error.message);
      },
    }
  );
};

export const useVerifyOtpLogin = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (verifyOtpAndResetPassword) => {
      const response = await client('/auth/login-verify-otp', {
        method: 'POST',
        data: verifyOtpAndResetPassword,
      });

      if (response?.error) {
        throw new Error(response.error);
      }
      
    if (response.access_token) {
      console.log('response...', response?.access_token)
      setTokenWithExpiry(response?.access_token);
      localStorage.setItem('email', response?.email);
      localStorage.setItem('username', response?.username);
      localStorage.setItem('userid', response?.userid);
      
      queryClient.invalidateQueries('token');
      return response;
    } else {
      throw new Error('Unexpected response from the server');
    }

      // return response;
    },
    {
      onSuccess: (data) => {
        console.log('✅ OTP Verified - response in useMutation:', data);
      },
      onError: (error) => {
        console.error('❌ OTP Verification Failed:', error.message);
      },
    }
  );
};


export const useGenerateSummary = () => {
  const generateSummary = async (summaryPayload) => {
    const response = await client('generate_summary', {
      method: 'POST',
      data: summaryPayload,
    });

    if (response?.error) {
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(generateSummary, {
    onSuccess: (data) => {
      console.log('✅ Summary generated successfully:', data);
    },
    onError: (error) => {
      console.error('❌ Failed to generate summary:', error.message);
    },
  });
};

// Read Users API - GET request
export const useReadUsers = (userId) => {
  return useQuery(
    ['readUsers', userId],
    async () => {
      const response = await client(`read_users/${userId}`);
      
      if (response?.error) {
        throw new Error(response.error);
      }
      
      return response;
    },
    {
      enabled: !!userId, // Only run query if userId is provided
      keepPreviousData: true,
    }
  );
};

// Update Users API - PUT request
export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  
  const updateUser = async (userData) => {
    const { userId, ...updateData } = userData;
    
    const response = await client(`update_users/${userId}`, {
      method: 'PUT',
      data: updateData,
      formEncoded: true, // Add this for form encoding if needed
    });

    if (response?.error) {
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(updateUser, {
    onSuccess: () => {
      // Invalidate users queries to refetch updated data
      queryClient.invalidateQueries(['readUsers']);
      queryClient.invalidateQueries(['readAllUsers']);
    },
    onError: (error) => {
      console.error('❌ Failed to update user:', error.message);
    },
  });
};

// Delete Users API - DELETE request
export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  
  const deleteUser = async (userId) => {
    const response = await client(`delete_users/${userId}`, {
      method: 'DELETE',
    });

    if (response?.error) {
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(deleteUser, {
    onSuccess: () => {
      // Invalidate users queries to refetch updated data
      queryClient.invalidateQueries(['readUsers']);
      queryClient.invalidateQueries(['readAllUsers']);
    },
    onError: (error) => {
      console.error('❌ Failed to delete user:', error.message);
    },
  });
};

export const useResendOtp = () => {
  const resendOtp = async (emailPayload) => {
    const response = await client('user/sendotp', {
      method: 'POST',
      data: emailPayload, // expects: { email: 'example@example.com' }
    });

    if (response?.error) {
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(resendOtp, {
    onSuccess: (data) => {
      console.log('✅ OTP resent successfully:', data);
    },
    onError: (error) => {
      console.error('❌ Failed to resend OTP:', error.message);
    },
  });
};

export const useResetPassword = () => {
  const resetPassword = async verifyPasswordForRegistrationData => {
    const response = await client('auth/resetPassword', {
      method: 'POST',
      data: verifyPasswordForRegistrationData,
    });

    if (response?.error) {
      // Assuming that your server returns an 'error' field when login fails
      throw new Error(response?.error);
    }

    return response;
  };

  return useMutation(resetPassword);
};

export const useStopWatchSet = () => {
  const queryClient = useQueryClient();
  const stopwatch = async stopwatchsetData => {
    const response = await client('auth/stopwatchSet', {
      method: 'POST',
      data: stopwatchsetData,
    });

    if (response?.error) {
      // Assuming that your server returns an 'error' field when login fails
      throw new Error(response?.error);
    }
    // console.log("response", response)
    // if(response){
    //   console.log("api res 1")
    //   return response
      
    // }else{
    //   console.log("api res 2")
    //   return "resumed"

    // }

    return response;
  };

  return useMutation(stopwatch, {
    onSuccess: () => {
      // Invalidate specific queries after the mutation is successful
      queryClient.invalidateQueries(['useStopWatchGet']); // Replace with the actual key used in the query
    },
  });
};

export const useStopWatchGet = id => {
  return useQuery(
    ['useStopWatchGet', id],
    async () => {
      let queryString = `auth/stopwatchget/${id}`;
      const response = await client(queryString);

      return response;
    },
    {
      keepPreviousData: true,
    }
  );
};

export const useAddDeviceToken = () => {
  const addDevice = async deviceToken => {
    const response = await client('auth/addDeviceToken', {
      method: 'POST',
      data: deviceToken,
    });

    console.log('response api', response);

    if (response?.error) {
      // Assuming that your server returns an 'error' field when login fails
      throw new Error(response?.error);
    }

    return response;
  };

  return useMutation(addDevice);
};

// Verify Reset OTP API
export const useVerifyResetOtp = () => {
  return useMutation(
    async (verifyResetOtpPayload) => {
      const response = await client('auth/verify-reset-otp', {
        method: 'POST',
        data: verifyResetOtpPayload,
      });
      console.log('response from verify otp api', response);
      if (response?.error) {
        throw new Error(response.error);
      }
   
      return response; // { message: "OTP verified" }
    },
    {
      onSuccess: (data) => {
        console.log('✅ Reset OTP verified successfully:', data);
      },
      onError: (error) => {
        console.error('❌ Failed to verify reset OTP:', error.message);
      },
    }
  );
};

// Reset Password API
export const useResetPasswordWithOtp = () => {
  return useMutation(
    async (resetPasswordPayload) => {
      const response = await client('auth/reset-password', {
        method: 'POST',
        data: resetPasswordPayload,
      });

      if (response?.error) {
        throw new Error(response.error);
      }

      return response; // e.g. { message: "Password reset successfully" }
    },
    {
      onSuccess: (data) => {
        console.log('✅ Password reset successfully:', data);
      },
      onError: (error) => {
        console.error('❌ Failed to reset password:', error.message);
      },
    }
  );
};

// Resend OTP for Login API
export const useResendOtpLogin = () => {
  return useMutation(
    async (email) => {
      const response = await client(`/auth/resend-otp?email=${encodeURIComponent(email)}`, {
        method: 'POST',
      });

      if (response?.error) {
        throw new Error(response.error);
      }

      return response;
    },
    {
      onSuccess: (data) => {
        console.log('✅ OTP resent successfully for login:', data);
      },
      onError: (error) => {
        console.error('❌ Failed to resend OTP for login:', error.message);
      },
    }
  );
};


export const useVerifyOtpSignUp = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (verifyOtpAndResetPassword) => {
      const response = await client('/register-verify-otp', {
        method: 'POST',
        data: verifyOtpAndResetPassword,
      });

      if (response?.error) {
        throw new Error(response.error);
      }
      
    if (response.access_token) {
      console.log('response...', response?.access_token)
      setTokenWithExpiry(response?.access_token);
      localStorage.setItem('email', response?.email);
      localStorage.setItem('username', response?.username);
      localStorage.setItem('userid', response?.userid);
      
      queryClient.invalidateQueries('token');
      return response;
    } else {
      throw new Error('Unexpected response from the server');
    }

      // return response;
    },
    {
      onSuccess: (data) => {
        console.log('✅ OTP Verified - response in useMutation:', data);
      },
      onError: (error) => {
        console.error('❌ OTP Verification Failed:', error.message);
      },
    }
  );
};

// Delete User Account API - DELETE request
export const useDeleteUserAccount = () => {
  const deleteUserAccount = async (userId) => {
    const response = await client(`delete_user/${userId}`, {
      method: 'DELETE',
    });

    if (response?.error) {
      throw new Error(response.error);
    }

    return response;
  };

  return useMutation(deleteUserAccount, {
    onSuccess: (data) => {
      console.log('✅ User account deleted successfully:', data);
    },
    onError: (error) => {
      console.error('❌ Failed to delete user account:', error.message);
    },
  });
};

// Reset Password API - PUT request (for authenticated users)
export const useResetPasswordDirect = () => {
  return useMutation(
    async (resetPasswordPayload) => {
      const response = await client('reset-password', {
        method: 'PUT',
        data: resetPasswordPayload,
      });

      if (response?.error) {
        throw new Error(response.error);
      }

      return response;
    },
    {
      onSuccess: (data) => {
        console.log('✅ Password reset successfully:', data);
      },
      onError: (error) => {
        console.error('❌ Failed to reset password:', error.message);
      },
    }
  );
};


